export default "__VITE_ASSET__c5a039c8__"